import { Navigate, Route } from 'react-router-dom'
import { WelcomePage } from './pages/WelcomePage'
import { DeveloperToolsPage } from './pages/DeveloperToolsPage'
import { ContentEntryPage } from './pages/ContentEntryPage'

/**
 * Dashboard feature route subtree.
 * Central router (app/router.tsx) composes these under the authenticated layout.
 */
export const dashboardRoutes = (
  <>
    <Route index element={<WelcomePage />} />
    <Route path="dev-tools" element={<DeveloperToolsPage />} />
    <Route path="api-tester" element={<Navigate to="/dev-tools" replace />} />
    <Route path="entry/:entryType/:entryId" element={<ContentEntryPage />} />
  </>
)
